jQuery(function ($) {
    jQuery('a[href^="tel:"]').click(function () {
        jQuery.post(ajaxurl, {
            action: 'post_phone_track',
            url: $(this)[0].href
        }, function (res) {

        }, 'json');
    });
});